export const FixtureSpriteColors = {
    GREEN_DARK_GREEN1_DARK_GREEN2: 'A0',
    DARK_BROWN1_GREY_ORANGE_BROWN: 'A1',
    LIGHT_BROWN2_BROWN3_YELLOW_BROWN: 'A2',
    LIGHT_YELLOW_YELLOW_ORANGE_YELLOW: 'A3',
    LIGHT_PINK_DARK_PURPLE_YELLOW: 'A4',
    GRAY_DARK_GRAY_LIGHTER_GRAY: 'A5',
    BLUE_DARK_BLUE_LIGHT_GRAY: 'A6',
    LIGHT_GRAY_BLUE_DARK_BLUE: 'A7',
    ORANGE_ORANGE_YELLOW_DARK_ORANGE: 'A8',
    BLUE_DARK_BLUE_PURPLE: 'A9',
    BLUE_ORANGE_YELLOW_PURPLE: 'B0',
    TEAL_LIGHT_BLUE1_PALE_AQUA: 'B1',
    DARK_BROWN_RED_DARK_RED_RED: 'B2',
    DARK_GRAY_ORANGE_RED_BLUE: 'B3',
    DARK_GRAY_LIGHT_PURPLE1_TAN_GREEN: 'B4',
    TAN_GREEN_DARK_GRAY_LIGHT_PURPLE1: 'B5',
    SKY_BLUE_PALE_BLUE_LIGHT_BLUE2: 'B6',
    LIGHT_BROWN2_REDDISH_BROWN_ORANGE_BROWN: 'B7',
    ORANGE_BROWN_REDDISH_BROWN_LIGHT_BROWN2: 'B8',
    DARKER_PURPLE_LIGHT_PURPLE2_LIGHT_YELLOW: 'B9',
    ORANGE_YELLOW_ORANGE_BROWN_LIGHT_BROWN2: 'C0',
    DARK_GRAY_LIGHT_PURPLE1_GREEN_BLUE: 'C1',
    BLUE_ORANGE_YELLOW_DARK_GRAY: 'C2',
    SKY_BLUE_BLUE_LIGHT_GREEN: 'C3',
    VERY_DARK_GREEN_TAN_WHITE_YELLOW: 'C4',
    BROWNISH_GREEN_DARK_RED_SUPER_DARK_GREEN: 'C5',
    YELLOW_ORANGE_DARK_GREEN2: 'C6',
    LIGHT_PURPLE2_DARKER_PURPLE_LIGHT_YELLOW: 'C7',
    DARK_GRAY_DARK_ORANGE_LIGHTER_GRAY: 'C8',
    DARK_ORANGE_DARK_GRAY_LIGHTER_GRAY: 'C9',
    LIGHTER_GRAY_DARK_ORANGE_DARK_GRAY: 'D0',
    LIME_GREEN1_DARK_BLUE_DARK_GRAY: 'D1',
    VERY_DARK_RED_SUPER_DARK_RED_ORANGE_RED: 'D2',
    ORANGE_RED_VERY_DARK_RED_SUPER_DARK_RED: 'D3',
    PURPLE_VERY_DARK_RED_SUPER_DARK_RED: 'D4',
    DARK_GRAY_LIGHT_GRAY_DARK_RED_PINK: 'D5',
    BLACK_LIGHT_BLUE1_LIGHT_BLUE2: 'D6',
    GREEN_BLUE_LIME_GREEN1_BLUE: 'D7',
    GREY_BLUE_GREEN_LIME_GREEN2_YELLOW_BROWN: 'D8',
    ORANGE_YELLOW_YELLOW_BROWN_TAN_GREEN: 'D9',
    LIGHT_BLUE_GREEN_BROWNISH_GREEN_LIME_GREEN2: 'E0',
    LIME_GREEN2_BROWNISH_GREEN_DARK_RED_ORANGE: 'E1',
    GRAY_DARK_BROWN3_DARKER_BROWN: 'E2',
    BLACK_DARKER_BROWN_DARK_BROWN3: 'E3',
    DARK_PURPLE_PURPLE_LIGHT_PURPLE1: 'E4',
    LIGHT_PURPLE1_ORANGE_RED_PURPLE: 'E5',
    GREEN_BROWN_DARK_BROWN2_DARK_GRAY: 'E6',
    SKY_BLUE_BROWNISH_GREEN_LIME_GREEN2: 'E7',
    RED_SKY_BLUE_BROWNISH_GREEN: 'E8',
};

function buildColorArray() {
    const colors = [];

    for (let color of Object.values(FixtureSpriteColors)){
        colors.push(color);
    }    

    return colors;
}

export const FixtureSpriteColorArray = buildColorArray();

